<template>
  <main class="speaker">
    <div class="speaker__siblings">
      <transition @enter="enterPrev">
        <router-link
          :to="`/${$route.params.city}/speakers/${prevSpeaker.path}`"
          class="speaker__sibling speaker__sibling--prev"
          v-if="prevSpeaker"
        >
          <AppPicture
            :data="{ src: prevSpeaker.pictureUrl, alt: prevSpeaker.title }"
            :isImg="false"
            :lazy="false"
            ref="prev"
          />
          <span class="sibling__caption u-hidden--from-ipadL">prev</span>
          <AppButton
            :data="{
              url: `/${$route.params.city}/speakers/${prevSpeaker.path}`,
              content: 'Prev'
            }"
            :router="true"
            ref="prevButton"
            :hasIcon="false"
          />
        </router-link>
      </transition>
      <transition @enter="enterNext">
        <router-link
          :to="`/${$route.params.city}/speakers/${nextSpeaker.path}`"
          class="speaker__sibling speaker__sibling--next"
          v-if="nextSpeaker"
        >
          <AppPicture
            :data="{ src: nextSpeaker.pictureUrl, alt: nextSpeaker.title }"
            :isImg="false"
            :lazy="false"
            ref="next"
          />
          <span class="sibling__caption u-hidden--from-ipadL">next</span>
          <AppButton
            :data="{
              url: `/${$route.params.city}/speakers/${nextSpeaker.path}`,
              content: 'Next'
            }"
            :router="true"
            ref="nextButton"
            :hasIcon="false"
          />
        </router-link>
      </transition>
    </div>
    <section>
      <article>
        <transition @enter="enter" appear>
          <div class="speaker__card">
            <span class="card__bg" ref="bg"/>
            <div class="speaker__picture-cont">
              <AppPicture
                ref="picture"
                class="speaker__picture"
                :data="{
                  src: currentSpeaker.pictureUrl,
                  alt: currentSpeaker.title
                }"
                :isImg="false"
                :lazy="false"
              />
              <h2
                class="speaker__role u-hidden--until-ipadL"
              >{{ currentSpeaker.subtitle }}</h2>
            </div>
            <h1
              class="speaker__name c-title c-title--light"
              v-html="currentSpeaker.title"
              ref="title"
            />
            <ul class="speaker__contacts">
              <li>
                <a
                  :href="currentSpeaker.twitter"
                  @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
                  @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
                >Twitter</a>
              </li>
              <li>
                <a
                  :href="currentSpeaker.website"
                  @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
                  @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
                >Website</a>
              </li>
            </ul>
          </div>
        </transition>
        <transition @enter="enterContent" appear>
          <h2
            class="speaker__role u-hidden--from-ipadL"
            data-lazyanimation="fade"
          >{{ currentSpeaker.subtitle }}</h2>
        </transition>
        <transition @enter="enterContent" appear>
          <p
            class="speaker__description"
            v-html="currentSpeaker.bio"
            data-lazyanimation="fade"
          />
        </transition>
      </article>
    </section>


    <AppSponsor class="speaker__sponsor" :sponsorList="sponsors[$route.params.city]" />

    <AppFooter />
  </main>
</template>

<script>
import anime from 'animejs';
import { mapGetters } from 'vuex';
import AppFooter from '@/components/AppFooter.vue';
import AppSponsor from '@/components/AppSponsor.vue';
import AppPicture from '@/components/AppPicture.vue';
import AppButton from '@/components/AppButton.vue';

import medusa from '@/scripts/medusa';
import { initials, animations } from '../scripts/fx';

import speakersList from '@/assets/data/contents/speakers.json';
import sponsors from '@/assets/data/contents/sponsor.json';


export default {
  name: 'Speaker',
  components: {
    AppFooter,
    AppSponsor,
    AppPicture,
    AppButton,
  },
  computed: {
    ...mapGetters(['contentReady']),
  },

  data() {
    return {
      data: null,
      currentSpeaker: null,
      nextSpeaker: null,
      prevSpeaker: null,
      dataAdded: false,
      speakersList,
      sponsors,
    };
  },
  mounted() {
    this.setCurrent();
    this.findNextPrev();
    this.$nextTick(() => medusa.recalculateTargets(this.$el));
  },
  methods: {
    setCurrent() {
      const speakerWs = this.speakersList[this.$route.params.city];

      const index = speakerWs.speakers.findIndex(workshop => this.$route.path.includes(workshop.path)); //eslint-disable-line
      this.currentSpeaker = speakerWs.speakers[index];
    },

    findNextPrev() {
      const speakerWs = this.speakersList[this.$route.params.city];
      const index = speakerWs.speakers.findIndex(workshop => this.$route.path.includes(workshop.path)); //eslint-disable-line
      const prevIndex = index === 0 ? speakerWs.speakers.length - 1 : index - 1;
      const nextIndex = index === speakerWs.speakers.length - 1 ? 0 : index + 1;
      this.prevSpeaker = speakerWs.speakers[prevIndex];
      this.nextSpeaker = speakerWs.speakers[nextIndex];
    },

    enter(el, done) {
      anime.set(this.$refs.picture.$el, { opacity: 0 });
      initials.get('title')(this.$refs.title);

      this.$refs.picture.loadPicture().then(() => this.enterAnimation(done));
      // this.addSpeakers();
    },
    // addSpeakers() {
    //   this.$store.dispatch('LOAD_PAGE', {
    //     city: this.$route.params.city,
    //     page: 'speakers',
    //   }).then(() => {
    //     const speakers = this.$store.state.speakers[this.$route.params.city];
    //     this.findNextPrev(speakers);
    //   });
    // },
    enterAnimation(done) {
      animations.get('title')(this.$refs.title);
      anime({
        targets: this.$refs.picture.$el,
        opacity: [0, 1],
        delay: 300,
        complete: done,
      });
    },
    enterPrev() {
      initials.get('fade')(this.$refs.prev.$el, 80);
      initials.get('button')(this.$refs.prevButton.$el);
      animations.get('fade')(this.$refs.prev.$el, 400, 0.3);
      animations.get('button')(this.$refs.prevButton.$el, 800);
    },
    enterNext() {
      initials.get('fade')(this.$refs.next.$el, 80);
      initials.get('button')(this.$refs.nextButton.$el);
      animations.get('fade')(this.$refs.next.$el, 400, 0.3);
      animations.get('button')(this.$refs.nextButton.$el, 800);
    },
    enterContent(el, done) {
      initials.get('fade')(el, 80);
      medusa.ref.pushToTarget('scrollAnimations', el);
      medusa.prevNodes.push(el);

      done();
    },
  },
  beforeDestroy() {
    this.$eventHub.$off('windowResize', this.calcVideoH);
    medusa.removePrevTargets();
  },
};
</script>

<style lang="scss" scoped>
.speaker {
  article {
    min-height: calc(var(--vh, 1vh) * 100);

    display: grid;
    grid-template-columns: repeat(13, 1fr);
    align-items: start;
    margin-top: $unit-vh * 0.5;

    @include mq(ds) {
      margin-top: $unit-vh * 3.5;
    }
  }

  &__card {
    position: relative;
    padding: 15px;
    margin: 0 $unit-vw * 2;

    grid-column: 2 / 13;

    @include mq(ipadP) {
      grid-column: 2 / 13;
      padding: 25px;
    }

    @include mq(ipadL) {
      grid-column: 4 / 10;
    }

    .card__bg {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: $color-white;

      z-index: -1;
    }
  }

  &__picture-cont {
    position: relative;
  }

  &__picture {
    @include aspect-ratio(13, 17);
  }

  &__name {
    position: absolute;
    top: -0.8em;
    left: -50%;
    width: 200%;
    margin: 0;

    text-align: center;

    @include fluid-type(
      375px,
      1024px,
      50px,
      135px,
      50px,
      135px
    );

    @include mq(ipadL) {
      @include fluid-type(
        1024px,
        3840px,
        56px,
        300px,
        68.4px,
        320px
      );
    }
  }

  &__role {
    position: relative;
    width: 100%;
    margin-top: $unit-vh;

    font-size: 1em;
    text-align: center;
    grid-row: 2;
    grid-column: 3 / 11;

    font-size: 16px;

    @include mq($from: dm) {
      font-size: 20px;
    }

    @include mq($from: dxl) {
      font-size: 24px;
    }

    @include mq(ipadL) {
      position: absolute;
      bottom: 50px;
      left: 15%;
      width: 70%;
      margin: 0;

      grid-row: unset;
      grid-column: unset;
    }
  }

  &__contacts {
    display: flex;
    align-items: baseline;
    justify-content: space-between;

    margin-top: 60px;

    font-size: 16px;

    @include mq($from: dm) {
      font-size: 20px;
    }

    @include mq($from: dxl) {
      font-size: 24px;
    }

    a {
      color: var(--color-bg);
    }
  }

  &__description {
    margin-top: $unit-vh;

    grid-column: 1 / -1;
    grid-row: 3;

    font-size: 20px;

    @include mq(ipadP) {
      grid-column: 2 / 13;
    }

    @include mq(ipadP) {
      font-size: 16px;
    }

    @include mq(d) {
      font-size: 20px;
    }

    @include mq(dm) {
      font-size: 24px;
    }

    @include mq(dxl) {
      font-size: 26px;
    }

    @include mq(ipadL) {
      grid-row: 2;
      margin-top: $unit-vh * 5;
      grid-column: 2 / 12;
    }
  }

  &__siblings {
    position: absolute;
    width: 100%;
    left: 0px;
    top: $unit-vh * 8;

    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  &__sibling {
    position: relative;
    width: 300px;
    top: $unit-vw * 3;

    z-index: 10;

    @include mq (ds) {
      top: $unit-vw * 6;
    }

    @include mq(d) {
      width: $unit-vw * 12;
    }

    &--prev {
      left: 0;
      transform: translateX(-85%);

      @include mq(ipadP) {
        transform: translateX(-70%);
      }

      @include mq(ipadL) {
        left: $unit-vw * -7;
        transform: none;
      }

      .sibling__caption {
        right: 5px;
        transform: rotate(-90deg);
      }

      .button {
        right: 0px;
        transform: rotate(-90deg) translateY(75px) translateX(25%);
      }
    }

    &--next {
      right: 0;
      transform: translateX(85%);

      @include mq(ipadP) {
        transform: translateX(70%);
      }

      @include mq(ipadL) {
        right: $unit-vw * -7;
        transform: none;
      }

      .sibling__caption {
        left: 0;
        transform: rotate(-90deg);
      }

      .button {
        left: 0px;
        transform: rotate(-90deg) translateY(-75px) translateX(25%);
      }
    }

    .sibling__caption {
      position: absolute;

      pointer-events: none;
      top: 50%;
    }

    .picture {
      @include aspect-ratio(13, 17);
      opacity: 0.3;
    }

    .button {
      position: absolute;
      top: 50%;

      @include mq($until: ipadL) {
        display: none;
      }

      & ::v-deep a {
        padding: 20px 60px;
      }
    }
  }
}
</style>
